import { LitElement, html, css } from 'https://cdn.jsdelivr.net/gh/lit/dist@2/core/lit-core.min.js';

export class SkioPlanPickerComponent extends LitElement {
  
  static properties = {
    product: { type: Object },
    selectedVariant: { type: Object },
    key: { type: String },
    formId: { type: String },
    skioSellingPlanGroups: {},
    availableSellingPlanGroups: {},
    selectedSellingPlanGroup: {},
    selectedSellingPlan: {},
    ajaxSubmit: { type: Boolean },
    moneyFormatter: {}
  };

  static styles = css`
    .skio-plan-picker {
      display: flex;
      flex-direction: column;
      gap: 10px;
      padding: 0;
      border: none;
      margin-bottom: 1rem;
    }
    
    
    .skio-plan-picker__header {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;

      display: none;
    }
    
    
    /*
    .skio-plan-picker__info {
      display: flex;
      align-items: center;
      flex-direction: column;
    }
    */
    
    .skio-plan-picker__price {
      font-weight: 700;
    }
    
    
    .skio-select {
      display: none;
      width: 100%;
      padding: 0.375rem 2.25rem 0.375rem 0.75rem;
      font-size: 1rem;
      font-weight: 400;
      line-height: 1.5;
      color: rgb(33, 37, 41);
      background-color: rgb(255, 255, 255);
      border: 1px solid #000;
      border-radius: 0;

      background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e");
      background-repeat: no-repeat;
      background-position: right 0.75rem center;
      background-size: 16px 12px;
      appearance: none;
    }    
    .skio-select--frequency {
      background-color: #fff;
    }
    .skio-label {
      display: block;
      margin: 1rem 0 0;
    }
    
  `;

  constructor() {
    super();
    // Define reactive properties--updating a reactive property causes the component to update.
    this.product = null;
    this.selectedVariant = null;

    this.key = null;
    this.formId = null;

    this.skioSellingPlanGroups = null;
    this.availableSellingPlanGroups = null;

    this.selectedSellingPlanGroup = null;
    this.selectedSellingPlan = null;

    this.ajaxSubmit = false;

    this.moneyFormatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: window?.Shopify?.currency?.active || 'USD',
    });

  }

  render() {

    return html`
      <fieldset class="skio-plan-picker" skio-plan-picker="${ this.key }" skio-auto-init>

        <input name="selling_plan" type="hidden" value="${ this.selectedSellingPlan !== null ? this.selectedSellingPlan.id : ''}" />

        <input name="properties[Discount]" type="hidden" value="${ this.selectedSellingPlan !== null ? this.discount(this.selectedSellingPlan).percent : '' }" disabled="${ this.selectedSellingPlan == null ? 'true' : 'false' }" />

        ${ this.availableSellingPlanGroups ? this.availableSellingPlanGroups.map((group, index) => 
          html`
            <div class="skio-plan-picker__header">
              <div class="skio-plan-picker__info">
                <span class="skio-plan-picker__price">${ this.price(group.selected_selling_plan) }</span>
                <span class="skio-plan-picker__discount">(-${ this.discount(group.selected_selling_plan).percent })</span>
              </div>
            </div>
          
            <select 
              skio-selling-plans="${ group.id }" 
              class="skio-select skio-select--frequency"
              @change=${ (e) => this.selectSellingPlan(e.target, group) }
              id="${`skio-frequency-`+this.key}" 
            >
            <option>
              Frequency
            </option>
              ${ group ? group.selling_plans.map((selling_plan) => 
                  html`
                    <option value="${ selling_plan.id }" ${this.selectedSellingPlan.id === selling_plan.id ? 'selected' : ''}>
                      ${ group.name == 'Subscription' ? `Delivery ${ selling_plan.name }` : `${ selling_plan.name }` }
                    </option>
                  `
                ): ''}
            </select>
          `
        ): ''}

      </fieldset>
    `
  }

  updated = (changed) => {
    if(changed.has('product')) {

      //update key
      this.key = this.product.id;

      //update skioSellingPlanGroups
      this.skioSellingPlanGroups = this.product.selling_plan_groups.filter(
        selling_plan_group => selling_plan_group.app_id === 'SKIO'
      )

    }

    if(changed.has('selectedVariant')) {

      //update availableSellingPlanGroups based on skioSellingPlanGroups and selectedVariant.id
      this.availableSellingPlanGroups = this.skioSellingPlanGroups.filter(selling_plan_group =>
        selling_plan_group.selling_plans.some(selling_plan =>
          this.selectedVariant.selling_plan_allocations.some(
            selling_plan_allocation => selling_plan_allocation.selling_plan_id === selling_plan.id
          )
        )
      )

      //update selectedSellingPlan value
      if (this.availableSellingPlanGroups.length > 0) {

        //update each group with a default selected_selling_plan
        this.availableSellingPlanGroups.forEach((group => {
          group.selected_selling_plan = group.selling_plans[0];
        }));

        this.selectedSellingPlanGroup = this.availableSellingPlanGroups[0];
        this.selectedSellingPlan = this.availableSellingPlanGroups[0].selling_plans[0];
      
      }

    }

    if (changed.has('selectedSellingPlan')) {
      //dispatch CustomEvent to tell that this specific plan picker was updated, and pass the selectedSellingPlan
      const event = new CustomEvent(`skio:update-selling-plan`, {bubbles: true, composed: true, detail: this.selectedSellingPlan});
      this.dispatchEvent(event);
      //update price of price elements if applicable
      document.querySelectorAll(`[skio-price][skio-key="${ this.key }"]`).forEach((el) => {
        el.innerHTML = this.price(this.selectedSellingPlan);
      });

      //update display of external content elements
      document.querySelectorAll(`[skio-onetime-content][skio-key="${ this.key }"]`).forEach((el) => {
        this.selectedSellingPlan !== null ? el.style.display = "none" : el.style.removeProperty('display');
      });
      document.querySelectorAll(`[skio-subscription-content][skio-key="${ this.key }"]`).forEach((el) => {
        this.selectedSellingPlan == null ? el.style.display = "none" : el.style.removeProperty('display');
      });
      

      //update the form that was passed, if any
      this.updateForm();
    }

    if (changed.has("ajaxSubmit")) {
      if(this.ajaxSubmit == true) {
        this.attachAjaxSubmit();
      }
    }

  }
  
  // Update selected selling plan group; called on click of skio-group-container element
  selectSellingPlanGroup(group) {
    if (group == null) {
      this.selectedSellingPlanGroup = null;
      this.selectedSellingPlan = null;
    } else {
      this.selectedSellingPlanGroup = group;
      this.selectedSellingPlan = group.selected_selling_plan;
    }
  }

  // Update selected selling plan; called on change of skio-frequency select element
  selectSellingPlan(element, group) {
    let selling_plan = group.selling_plans.find(x => x.id == element.value);
    if (selling_plan) {
      group.selected_selling_plan = selling_plan;
      this.selectedSellingPlanGroup = group;
      this.selectedSellingPlan = selling_plan;
    }
    else console.log("Error: couldn't find selling plan with id " + element.value + " for variant " + this.selectedVariant.id + " from product " + this.product.id + " : " + this.product.handle);
  }

  // If a form ID was passed, updates the form's selling_plan and property[Discount] fields
  updateForm() {
    if (this.formId) {
      let form = document.querySelector("#" + this.formId);
      if (form) {
        let selling_plan_input = form.querySelector('[name="selling_plan"]');
        if (selling_plan_input) selling_plan_input.value = this.selectedSellingPlan !== null ? this.selectedSellingPlan.id : null;
        else {
          selling_plan_input = document.createElement('input');
          selling_plan_input.type = "hidden";
          selling_plan_input.name = "selling_plan";
          selling_plan_input.value = this.selectedSellingPlan !== null ? this.selectedSellingPlan.id : null;
          form.append(selling_plan_input);
        }

        let discount_input = form.querySelector('[name="properties[Discount]"]');
        if (discount_input) discount_input.value = this.selectedSellingPlan !== null ? this.discount(this.selectedSellingPlan).percent : null;
        else {
          discount_input = document.createElement('input');
          discount_input.type = "hidden";
          discount_input.name = "properties[Discount]";
          discount_input.value = this.selectedSellingPlan !== null ? this.discount(this.selectedSellingPlan).percent : null;
          form.append(discount_input);
        }
      } else {
        console.log(`Skio error: form ID is ${ this.formId }, but no form with that ID was found.`);
      }
    }
  }

  // Formats integer value into money value
  money(price) {
    return this.moneyFormatter.format(price / 100.0)
  }

  // Calculates discount based on selling_plan.price_adjustments, returns { percent, amount } of selling plan discount
  discount(selling_plan) {
    if (!selling_plan)
      return { percent: '0%', amount: 0 }
    
    const price_adjustment = selling_plan.price_adjustments[0]
    const discount = { percent: '0%', amount: 0 }
    const price = this.selectedVariant.price;

    if(this.subscriptionDiscountOverride) {
      return { 
        percent: this.subscriptionDiscountOverride + '%', 
        amount:  Math.round((price * this.subscriptionDiscountOverride) / 100.0)
      }
    }
    
    switch (price_adjustment.value_type) {
      case 'percentage':
        discount.percent = `${price_adjustment.value}%`
        discount.amount = Math.round(
          (price * price_adjustment.value) / 100.0
        )
        break
      case 'fixed_amount':
        discount.percent = `${Math.round(
          ((price_adjustment.value * 1.0) / price) * 100.0
        )}%`
        discount.amount = price_adjustment.value
        break
      case 'price':
        discount.percent = `${Math.round(
          (((price - price_adjustment.value) * 1.0) /
            price) *
            100.0
        )}%`
        discount.amount = price - price_adjustment.value
        break
    }
    
    return discount
  }

  // Calculates the variant's price for the given selling plan, returns a formatted money value (if desired)
  price(selling_plan, formatted = true) {
    const compareAt = this.selectedVariant.compare_at_price > this.selectedVariant.price ? this.selectedVariant.compare_at_price : this.selectedVariant.price;
    return formatted
      ? this.money(compareAt - this.discount(selling_plan).amount)
      : compareAt - this.discount(selling_plan).amount
  }

  // Runs a fetch request to add the selectedVariant to the cart with the passed quantity and selectedSellingPlan
  addToCart(quantity) {
    const items = [
      {
        id: this.selectedVariant.id,
        quantity: quantity,
        selling_plan: this.selectedSellingPlan.id
      }
    ];
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items })
    })
    .then((response) => response.json())
    .then((response) => {
      console.log("SKIO added item to cart: ", response);
      //dispatch CustomEvent to tell document that an item was added to cart
      const event = new CustomEvent(`skio:${ this.key }:added-to-cart`, {bubbles: true, composed: true, detail: response});
      
      this.dispatchEvent(event);
    })
    .catch((error) => {
      console.error(`SKIO ${ this.key } error adding item to cart: `, error);
    });
  }

  attachAjaxSubmit() {
    const vm = this;
    // overrides the "submit" of any form with [skio-add-to-cart-form] to ensure that the 
    // selling_plan input and properties[Discount] input are included in form submission; could also
    // have passed the formId has a param to auto-add the inputs to the form, either works
    document.querySelectorAll(`[skio-add-to-cart-form][skio-key="${ this.key }"]`).forEach((form) => {
      if (form.querySelector('[name="id"]')) {
        if (form.querySelector('[name="id"]').value == document.querySelector('skio-plan-picker').selectedVariant.id) {
          let quantity = form.querySelector('[name="quantity"]');
          if (!quantity) quantity = document.querySelector('[name="quantity"][form="' + form.getAttribute('id') + '"]')
          form.querySelectorAll('button[type="submit"]').forEach((btn) => {
            btn.addEventListener("click", function(e) {
              e.preventDefault();
              e.stopPropagation();
              e.stopImmediatePropagation();
              let selling_plan = document.querySelector('skio-plan-picker').selectedSellingPlan;
              if (selling_plan) {
                let selling_plan_input = document.createElement('input');
                selling_plan_input.type = "hidden";
                selling_plan_input.name = "selling_plan";
                selling_plan_input.value = selling_plan.id;
                form.append(selling_plan_input);
                let discount_input = document.createElement('input');
                discount_input.type = "hidden";
                discount_input.name = "properties[Discount]";
                discount_input.value = document.querySelector('skio-plan-picker').discount(selling_plan).percent;
                form.append(discount_input);
              }
              form.submit();
            });
          });
        }
      }
    });

    // overrides the "click" event of any element with [skio-add-to-cart-btn] and runs an addToCart; can add 
    // [skio-quantity] and  [skio-key=${key}] to any input / select element to change the quantity for the 
    // addToCart call from 1 to any user input value
    document.querySelectorAll(`[skio-add-to-cart-btn][skio-key="${ this.key }"]`).forEach((btn) => {
      btn.addEventListener("click", function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        let quantity = 1;
        let quantity_el = document.querySelector(`[skio-quantity][skio-key="${ this.key }"`);
        if (quantity_el) quantity = quantity_el.value;
        vm.addToCart(quantity);
      });
    });

  }
  
}

customElements.define('skio-plan-picker', SkioPlanPickerComponent);